import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { motion, useScroll, useSpring } from 'framer-motion';

const LenisContext = createContext(null);

export const useLenis = () => useContext(LenisContext);

// Plynulý (setrvačný) scroll. Při „omezit pohyb“ v systému zůstává nativní scroll.
export const SmoothScroll = ({ children }) => {
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const instance = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    let frame;
    const raf = (time) => {
      instance.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    setLenis(instance);
    return () => {
      cancelAnimationFrame(frame);
      instance.destroy();
      setLenis(null);
    };
  }, []);

  return <LenisContext.Provider value={lenis}>{children}</LenisContext.Provider>;
};

export const scrollToTarget = (lenis, target, options = {}) => {
  if (lenis) {
    lenis.scrollTo(target, { offset: -60, ...options });
  } else if (typeof target === 'number') {
    window.scrollTo({ top: target, behavior: options.immediate ? 'auto' : 'smooth' });
  } else {
    target.scrollIntoView({ behavior: 'smooth' });
  }
};

// Po změně adresy doscrolluje na #kotvu, případně nahoru na novou stránku.
export const ScrollManager = () => {
  const { hash, key } = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    const timer = setTimeout(() => {
      const el = hash && document.getElementById(hash.slice(1));
      if (el) scrollToTarget(lenis, el);
      else scrollToTarget(lenis, 0, { immediate: true });
    }, 60);
    return () => clearTimeout(timer);
  }, [key, hash, lenis]);

  return null;
};

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, restDelta: 0.001 });
  return <motion.div className="scroll-progress" style={{ scaleX }} aria-hidden="true" />;
};
